<div class="d-flex flex-column g-space-sm">
  @if (this.contact().lastName || this.contact().firstName) {
    <div class="d-flex space-between align-center g-space-sm">
      <cam-item-display [label]="'core.contact-profile.full-name'">
        {{
          this.fullName({
            firstName: this.contact().firstName ?? '',
            name: this.contact().lastName ?? '',
          })
        }}
      </cam-item-display>
      @if (this.editable()) {
        <cam-font-icon class="pointer" name="modify" type="sm" (click)="this.edit.emit()"></cam-font-icon>
      }
    </div>
  }
  @if (this.contact().phoneNumber || this.contact().mail) {
    <div class="info-grid">
      <cam-item-display [label]="'core.contact-profile.phone'">
        @if (this.contact().phoneNumber) {
          <cam-link [underline]="false" icon="phone" [size]="'sm'">{{ this.contact().phoneNumber }}</cam-link>
        } @else {
          {{ 'core.contact-profile.not-available' | translate }}
        }
      </cam-item-display>
      <cam-item-display [label]="'core.contact-profile.email'">
        @if (this.contact().phoneNumber) {
          <cam-link [underline]="false" icon="mail" [size]="'sm'">{{ this.contact().mail }}</cam-link>
        } @else {
          {{ 'core.contact-profile.not-available' | translate }}
        }
      </cam-item-display>
    </div>
  }
  @if (this.contact().vatNumber) {
    <cam-item-display [label]="'core.contact-profile.vat-number'">
      {{ this.contact().vatNumber }}
    </cam-item-display>
  }
  @if (this.withInvoicingAddress()) {
    <cam-item-display [label]="'core.contact-profile.invoicing-address'">
      @if (this.invoicingAddress(); as invoicingAddress) {
        {{ this.formatAddress(invoicingAddress) }}
      } @else {
        {{ 'core.contact-profile.not-available' | translate }}
      }
    </cam-item-display>
  }
</div>
